<!-- Группирует плавающие действия приложения и поднимает их над фиксированным footer формы. -->
<template>
  <div
    class="app-floating-actions"
    :class="{
      'app-floating-actions--above-form-footer': aboveFormFooter,
    }"
  >
    <ScrollToTop
      v-if="showScrollToTop"
      :floating="false"
      scroll-container-selector=".content"
    />
    <SupportWidget
      :floating="false"
      :force-collapsed="forceCollapseSupportWidget"
    />
  </div>
</template>

<script>
import ScrollToTop from "@/components/ScrollToTop.vue";
import SupportWidget from "@/components/Support/Widget.vue";

export default {
  name: "AppFloatingActions",

  components: {
    ScrollToTop,
    SupportWidget,
  },

  props: {
    showScrollToTop: {
      type: Boolean,
      default: true,
    },
    forceCollapseSupportWidget: {
      type: Boolean,
      default: false,
    },
    aboveFormFooter: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.app-floating-actions {
  --app-floating-action-size: 48px;

  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 1800;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: var(--app-floating-action-size);
  pointer-events: none;
}

.app-floating-actions--above-form-footer {
  bottom: 72px;
}

.app-floating-actions > * {
  pointer-events: auto;
}

@media (max-width: 768px) {
  .app-floating-actions {
    --app-floating-action-size: 46px;

    right: 16px;
    bottom: 16px;
  }

  .app-floating-actions--above-form-footer {
    bottom: 70px;
  }
}
</style>
